import {Card, CardContent, CardMedia, styled, Typography} from '@mui/material';

const StyledCard = styled(Card)`
	margin: 16px auto 0;
	max-width: 852px;
	display: flex;
	flex-direction: column;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
	}
`;

const StyledCardContent = styled(CardContent)`
	padding: 16px;
	gap: 8px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`;

const StyledCardMedia = styled(CardMedia)`
	width: 100%;
	height: auto;
	object-fit: cover;

	${({theme}) => theme.breakpoints.up('sm')} {
		width: 40%;
		max-height: 100%;
	}
` as typeof CardMedia;

const TitleTypography = styled(Typography)`
	font-weight: 600;
	color: ${({theme}) => theme.colors.light.primary.main};
`;

const DescriptionTypography = styled(Typography)`
	font-size: 14px;
`;

export {StyledCard, StyledCardContent, StyledCardMedia, TitleTypography, DescriptionTypography};
